type ModalProps = {
  closeModal(): void;
  children?: React.ReactNode;
};

const Modal = ({ closeModal, children }: ModalProps) => {
  return (
    <div className='opacity-98 z-99999 fixed bottom-0 left-0 right-0 top-0 overflow-y-scroll bg-blue-100 transition-all duration-300'>
      <div className='h-84 w-full bg-linear-to-b from-white via-transparent'></div>
      <div className={`mx-auto ml-4 flex w-full justify-between`}>
        <button
          onClick={closeModal}
          className='bg-image-24 mt-29 hover:bg-with relative ml-auto h-9 w-16 cursor-pointer bg-center bg-no-repeat hover:opacity-60'
        >
          <img src='/icon-close-modal.svg' alt='Fechar modal' />
        </button>
      </div>
      <div className='content-modal'>{children}</div>
    </div>
  );
};

export default Modal;
